import { AvailableDeliveryMethodsDetail } from "../../interfaces/session/ShoppingCart";
import { DELIVERY_METHODS } from "./helper";

export function getDeliveryMethodDetails(availableDeliveryMethodsDetails: AvailableDeliveryMethodsDetail[]) {
  const pickupDetails = availableDeliveryMethodsDetails?.find((el) => el.deliveryMethod === DELIVERY_METHODS.PICKUP);
  const deliveryDetails = availableDeliveryMethodsDetails?.find((el) => el.deliveryMethod === DELIVERY_METHODS.DELIVERY);
  const shipmentDetails = availableDeliveryMethodsDetails?.find((el) => el.deliveryMethod === DELIVERY_METHODS.SHIPPING);
  return { pickupDetails, deliveryDetails, shipmentDetails };
}
